import React from 'react';

// Import components
import ItemLink from 'components/views/vod/components/sliders/components/ItemLink';

const LinkWrapper = ({ status, url, children }) => {
	if (status === 'ready') {
		return (
			<ItemLink to={url} isStyledByChildren>
				{children}
			</ItemLink>
		);
	}

	return children;
};

export default LinkWrapper;
